<template>
	<div>
		<Card class="winner-bracket-block tournament-stage table-card-style pb-4">
			<h3 class="my-4">Winner Bracket</h3>
			<div class="winner-table-block">
				<Row :gutter="16" class="d-flex flex-column">
					<Col class="d-flex justify-content-around w-100">
						<Card
							v-for="match in wildcard.filter(({ playoffStage }) => playoffStage === 0.5)"
							:key="match._id"
							class="tournament-stage table-card-style loose-background mb-3 w-24procent"
						>
							<table class="match-table looser-111">
								<tbody>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.home_team.name }}</span>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">{{ getPoints(match.home_players, match, match.home_team) }} </span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, wildcard)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.away_team.name }}</span>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">{{ getPoints(match.away_players, match, match.away_team) }} </span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
						<Card
							v-for="match in wildcard.filter(({ playoffStage }) => playoffStage === 1)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.home_team.name }}</span>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">{{ getPoints(match.home_players, match, match.home_team) }} </span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, wildcard)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.away_team.name }}</span>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">{{ getPoints(match.away_players, match, match.away_team) }} </span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>
				</Row>
				<Row :gutter="16" class="d-flex flex-column">
					<Col class="d-flex justify-content-around w-100">
						<div v-if="wildcard.filter(({ playoffStage }) => playoffStage === 0.5)" class="w-24procent h-100">
							<Card
								v-for="match in wildcard.filter(({ playoffStage }) => playoffStage === 2.5)"
								:key="match._id"
								class="tournament-stage table-card-style mb-3 loose-background w-100"
							>
								<table class="match-table">
									<tbody>
										<tr
											:class="`${
												getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
											}`"
										>
											<td>
												<span v-if="matches.length">{{ match.home_team.name ? match.home_team.name : match.home_team }}</span>
											</td>
											<td class="w-70px position-relative">
												<span v-if="matches.length">{{ getPoints(match.home_players, match, match.home_team) }} </span>
												<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, wildcard)" />
											</td>
										</tr>
										<tr
											:class="`${
												getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
											}`"
										>
											<td>
												<span v-if="matches.length">{{ match.away_team.name ? match.away_team.name : match.away_team }}</span>
											</td>
											<td class="w-70px">
												<span v-if="matches.length">{{ getPoints(match.away_players, match, match.away_team) }} </span>
											</td>
										</tr>
									</tbody>
								</table>
							</Card>
						</div>

						<Card
							v-for="match in wildcard.filter(({ playoffStage }) => playoffStage === 2)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.home_team.name }}</span>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">{{ getPoints(match.home_players, match, match.home_team) }} </span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, wildcard)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.away_team.name ? match.away_team.name : match.away_team }}</span>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">{{ getPoints(match.away_players, match, match.away_team) }} </span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>
				</Row>
				<Row :gutter="16" class="d-flex flex-column">
					<Col class="d-flex special-position-block w-100">
						<div v-if="wildcard.filter(({ playoffStage }) => playoffStage === 0.5)" class="w-12procent"></div>
						<Card
							v-for="match in wildcard.filter(({ playoffStage }) => playoffStage === 3)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.home_team.name ? match.home_team.name : match.home_team }}</span>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">{{ getPoints(match.home_players, match, match.home_team) }} </span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, wildcard)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.away_team.name ? match.away_team.name : match.away_team }}</span>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">{{ getPoints(match.away_players, match, match.away_team) }} </span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>
				</Row>
			</div>
		</Card>
		<Card v-if="this.wildcard.some(({ playoffStage }) => playoffStage < 0)" class="tournament-stage table-card-style pb-4 mt-4">
			<h3 v-if="this.wildcard.some(({ playoffStage }) => playoffStage < 0)" class="my-4">
				Consolation Bracket
			</h3>
			<div class="winner-table-block">
				<Row :gutter="16" class="d-flex flex-column">
					<Col class="d-flex justify-content-around w-100">
						<Card
							v-for="match in wildcard.filter(({ playoffStage }) => playoffStage === -0.5)"
							:key="match._id"
							class="tournament-stage table-card-style loose-background mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.home_team.name }}</span>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">{{ getPoints(match.home_players, match, match.home_team) }} </span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, wildcard)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.away_team.name }}</span>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">{{ getPoints(match.away_players, match, match.away_team) }} </span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
						<Card
							v-for="match in wildcard.filter(({ playoffStage }) => playoffStage === -1)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.home_team.name }}</span>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">{{ getPoints(match.home_players, match, match.home_team) }} </span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, wildcard)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.away_team.name }}</span>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">{{ getPoints(match.away_players, match, match.away_team) }} </span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>
				</Row>
				<Row :gutter="16" class="d-flex flex-column">
					<Col class="d-flex justify-content-around w-100">
						<div v-if="wildcard.filter(({ playoffStage }) => playoffStage === -0.5)" class="w-24procent h-100">
							<Card
								v-for="match in wildcard.filter(({ playoffStage }) => playoffStage === -2.5)"
								:key="match._id"
								class="tournament-stage table-card-style mb-3 loose-background w-100"
							>
								<table class="match-table">
									<tbody>
										<tr
											:class="`${
												getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
											}`"
										>
											<td>
												<span v-if="matches.length">{{ match.home_team.name ? match.home_team.name : match.home_team }}</span>
											</td>
											<td class="w-70px position-relative">
												<span v-if="matches.length">{{ getPoints(match.home_players, match, match.home_team) }} </span>
												<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, wildcard)" />
											</td>
										</tr>
										<tr
											:class="`${
												getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
											}`"
										>
											<td>
												<span v-if="matches.length">{{ match.away_team.name ? match.away_team.name : match.away_team }}</span>
											</td>
											<td class="w-70px">
												<span v-if="matches.length">{{ getPoints(match.away_players, match, match.away_team) }} </span>
											</td>
										</tr>
									</tbody>
								</table>
							</Card>
						</div>
						<Card
							v-for="match in wildcard.filter(({ playoffStage }) => playoffStage === -2)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.home_team.name }}</span>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">{{ getPoints(match.home_players, match, match.home_team) }} </span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, wildcard)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.away_team.name ? match.away_team.name : match.away_team }}</span>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">{{ getPoints(match.away_players, match, match.away_team) }} </span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>
				</Row>
				<Row :gutter="16" class="d-flex flex-column">
					<Col class="d-flex special-position-block w-100">
						<div v-if="wildcard.filter(({ playoffStage }) => playoffStage === -0.5)" class="w-12procent"></div>
						<Card
							v-for="match in wildcard.filter(({ playoffStage }) => playoffStage === -3)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.home_team.name ? match.home_team.name : match.home_team }}</span>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">{{ getPoints(match.home_players, match, match.home_team) }} </span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, wildcard)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<span v-if="matches.length">{{ match.away_team.name ? match.away_team.name : match.away_team }}</span>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">{{ getPoints(match.away_players, match, match.away_team) }} </span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>
				</Row>
			</div>
		</Card>
	</div>
</template>

<script>
	import storeMixin from '../storeMixin';
	export default {
		name: 'Wildcard2Groups',
		data() {
			return storeMixin;
		},
	};
</script>

<style scoped>
	.loose-background {
		background-color: #ffddd4 !important;
	}

	.looser-position {
		position: absolute;
		top: 0;
		left: 100px;
		height: inherit;
	}

	.w-24procent {
		/* width: 275px; */
		width: 24%;
	}

	.w-12procent {
		/* width: 275px; */
		width: 12%;
	}

	.single-groups-clamp-text {
		width: 100%;
	}

	table {
		table-layout: fixed;
	}

	.w-70px {
		width: 70px;
		min-width: 70px;
	}

	.special-position-block {
		justify-content: space-evenly !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/competitions/schemes/formats/groups/Wildcard2Groups.vue